import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VDataFooter from 'vuetify/lib/components/VDataIterator/VDataFooter';
import cs from 'vuetify/es5/locale/cs';

VDataFooter.extendOptions.props
  .itemsPerPageOptions.default = () => ([10, 20, 40]);

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: {
      cs,
      noDataText: 'Nebyla nalezena žádná data',
    },
    current: 'cs',
  },
  theme: {
    themes: {
      light: {
        primary: '#1C2F67',
        success: '#1C2F67',
      },
    },
  },
});
